/* @flow */

import cloneDeep from 'lodash/cloneDeep';
import { TURNOS_POR_DIA_SEMANA_INICIAL } from './constants';
import { type Funcionamento, type FuncionamentosPorDiaSemana } from './types';

const getHorariosPorDiaSemana = (horarios: Funcionamento[]): FuncionamentosPorDiaSemana => {
    const porDiaSemana = cloneDeep(TURNOS_POR_DIA_SEMANA_INICIAL);
    horarios.forEach((func) => {
        porDiaSemana[func.diaSemanaId].push(func);
    });
    return porDiaSemana;
};

export default getHorariosPorDiaSemana;
